<template>
  <div class="user-type-selection">
    <!-- Main Content -->
    <div class="selection-container">
      <!-- Header -->
      <div class="selection-header">
        <div class="flamou-container">
          <img src="@/assets/flamou/happy.png" alt="Flamou" class="flamou-icon" />
        </div>
        <h1 class="page-title">Bienvenue sur Autrement Capable</h1>
        <p class="page-subtitle">
          Choisissez votre profil pour commencer votre aventure
        </p>
      </div>

      <!-- User Type Cards -->
      <div class="cards-grid">
        <!-- Jeune Card -->
        <div class="user-card young-card" @click="goToYoungOnboarding">
          <div class="card-icon">👩‍🎓</div>
          <h2 class="card-title">Je suis un jeune</h2>
          <p class="card-description">
            Découvre tes forces et construis ton projet professionnel à travers des jeux et des activités
          </p>
          <button class="card-button young-button">
            Commencer
            <span class="button-arrow">→</span>
          </button>
        </div>

        <!-- Accompagnant Card -->
        <div class="user-card accompanist-card" @click="goToAccompanistOnboarding">
          <div class="card-icon">👨‍🏫</div>
          <h2 class="card-title">Je suis un accompagnant</h2>
          <p class="card-description">
            Accompagne les jeunes dans leur connaissance de soi en valorisant ses compétences pour construire son parcours d'orientation professionnel 
          </p>
          <button class="card-button accompanist-button">
            Commencer
            <span class="button-arrow">→</span>
          </button>
        </div>
      </div>

      <!-- Back Button -->
      <div class="back-section">
        <button class="back-button" @click="goBack">
          <span class="back-arrow">←</span>
          Retour à l'accueil
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserTypeSelection',
  methods: {
    goToYoungOnboarding() {
      this.$router.push('/jeune/login');
    },
    goToAccompanistOnboarding() {
      this.$router.push('/accompagnant/login');
    },
    goBack() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.user-type-selection {
  min-height: 100vh;
  background: #F9FAFB;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

/* Main Container */
.selection-container {
  max-width: 1200px;
  width: 100%;
  position: relative;
  z-index: 1;
}

/* Header */
.selection-header {
  text-align: center;
  margin-bottom: 3rem;
}

.flamou-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

.flamou-icon {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #111827;
  margin: 0 0 1rem 0;
  background: linear-gradient(135deg, #FF9800 0%, #FF9800 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-subtitle {
  font-size: 1.25rem;
  color: #6B7280;
  margin: 0;
}

/* Cards Grid */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* User Cards */
.user-card {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  border: 3px solid transparent;
  display: flex;
  flex-direction: column;
}

.user-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.user-card:hover::before {
  opacity: 1;
}

.user-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.young-card {
  border-color: #FED7AA;
}

.young-card:hover {
  border-color: #FF9800;
  box-shadow: 0 20px 40px rgba(255, 152, 0, 0.3);
}

.accompanist-card {
  border-color: #FED7AA;
}

.accompanist-card:hover {
  border-color: #FF9800;
  box-shadow: 0 20px 40px rgba(255, 152, 0, 0.3);
}

.card-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.card-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 1rem 0;
}

.card-description {
  font-size: 1rem;
  color: #6B7280;
  line-height: 1.6;
  margin: 0 0 1rem 0;
  flex-grow: 1;
}

/* Card Buttons */
.card-button {
  width: 100%;
  padding: 0.875rem 1.75rem;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  margin-top: auto; 
}

.young-button {
  background: #FF9800;
  color: white;
  box-shadow: 0 4px 16px rgba(255, 152, 0, 0.3);
}

.young-button:hover {
  box-shadow: 0 8px 24px rgba(255, 152, 0, 0.5);
}

.accompanist-button {
  background: #FF9800;
  color: white;
  box-shadow: 0 4px 16px rgba(255, 152, 0, 0.3);
}

.accompanist-button:hover {
  box-shadow: 0 8px 24px rgba(255, 152, 0, 0.5);
}

.button-arrow {
  font-size: 1.5rem;
  transition: transform 0.3s ease;
  position: relative;
  z-index: 1;
}

.card-button:hover .button-arrow {
  transform: translateX(6px);
}

/* Back Section */
.back-section {
  text-align: center;
  margin-top: 3rem;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1.75rem;
  background: white;
  border: 2px solid #E5E7EB;
  border-radius: 12px;
  color: #6B7280;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.back-button:hover {
  background: #F9FAFB;
  border-color: #FF9800;
  color: #FF9800;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.back-arrow {
  font-size: 1.25rem;
  transition: transform 0.3s ease;
}

.back-button:hover .back-arrow {
  transform: translateX(-4px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .user-type-selection {
    padding: 1.5rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .cards-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .user-card {
    padding: 1.75rem;
  }

  .card-icon {
    font-size: 2.5rem;
  }

  .card-title {
    font-size: 1.375rem;
  }

  .card-description {
    font-size: 0.875rem;
  }

  .flamou-icon {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 480px) {
  .user-type-selection {
    padding: 1rem;
  }

  .selection-header {
    margin-bottom: 2rem;
  }

  .page-title {
    font-size: 1.75rem;
  }

  .user-card {
    padding: 1.5rem;
  }

  .card-button {
    padding: 0.75rem 1.25rem;
    font-size: 0.9375rem;
  }
}

/* Accessibility */
.user-card:focus-visible,
.card-button:focus-visible,
.back-button:focus-visible {
  outline: 3px solid #FF9800;
  outline-offset: 4px;
}

/* Print Styles */
@media print {
  .user-card {
    box-shadow: none;
    border: 2px solid #E5E7EB;
  }
}
</style>
